/* eslint-disable react/display-name */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Switch, Route, useRouteMatch, Link, Redirect, useParams } from 'react-router-dom';

import {
  makeStyles,
  Grid,
  Divider,
  Button,
  Hidden
} from '@material-ui/core';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import NavBar from './features/layout/NavBar';
import SideBar from './features/layout/SideBar';
import PinList from './features/pins/PinList';
import ItemFamiliesPage from './features/itemFamilies/itemFamiliesPage';
import ItemFamilyPage from './features/itemFamily/itemFamilyPage';
import AddItemFamilyPage from './features/itemFamily/AddItemFamilyPage';
import ItemsPage from './features/items/itemsPage';
import ItemPage from './features/item/itemPage';
import ItemSearchesPage from './features/itemSearches/itemSearchesPage';
import FeedsPage from './features/feeds/feedsPage';
import FeedPage from './features/feeds/feedPage';
import UserSettingsPage from './features/user/userSettingsPage';
import TyreAwardsPage from './features/tyreAwards/tyreAwardsPage';
import TyreAwardPage from './features/tyreAwards/tyreAwardPage';
import WheelsPage from './features/wheels/wheelsPage';
import WheelPage from './features/wheel/wheelPage';
import AddWheelPage from './features/wheel/addWheelPage';
import TreadsPage from './features/treads/treadsPage';
import TreadPage from './features/tread/treadPage';
import TreadItemPage from './features/item/treadItemPage';
import AddTreadPage from './features/tread/addTreadPage';
import TreadItemsPage from './features/items/treadItemsPage';
import CatalogPage from './features/catalog/catalogPage';

const routes = [
  {
    path: '/',
    exact: true,
    main: () => <Redirect to="/pih/owner/PC1/items" />
  },
  {
    path: '/owner',
    exact: true,
    main: () => <Redirect to="/pih/owner/PC1/items" />
  },
  {
    path: '/owner/:itemOwnerId/families/new',
    main: AddItemFamilyPage
  },
  {
    path: '/owner/:itemOwnerId/families/:itemFamilyId',
    main: ItemFamilyPage
  },
  {
    path: '/owner/:itemOwnerId/families',
    main: ItemFamiliesPage
  },
  {
    path: '/owner/:itemOwnerId/items/:itemId',
    main: ItemPage
  },
  {
    path: '/owner/:itemOwnerId/items',
    main: ItemsPage
  },
  {
    path: '/owner/:itemOwnerId/feeds',
    exact: true,
    main: FeedsPage
  },
  {
    path: '/owner/:itemOwnerId/feeds/:feedId',
    main: FeedPage
  },
  {
    path: '/owner/:itemOwnerId/saved-searches',
    main: ItemSearchesPage
  },
  {
    path: '/owner/:itemOwnerId/tyre-awards',
    main: TyreAwardsPage
  },
  {
    path: '/owner/:itemOwnerId/tyre-award/new',
    main: TyreAwardPage
  },
  {
    path: '/owner/:itemOwnerId/tyre-award/:awardId',
    main: TyreAwardPage
  },
  {
    path: '/owner/:itemOwnerId/catalog',
    main: CatalogPage,
  },
  {
    path: '/settings',
    main: UserSettingsPage
  },
  {
    path: '/owner/:itemOwnerId/wheels/new',
    main: AddWheelPage,
  },
  {
    path: '/owner/:itemOwnerId/wheels/:wheelId',
    main: WheelPage,
  },
  {
    path: '/owner/:itemOwnerId/wheels',
    main: WheelsPage,
  },
  // Redirect all /rims to /wheels NHTCONT-648
  {
    path: '/owner/:itemOwnerId/rims*',
    main: (props) => {
      const {itemOwnerId, ...rest} = useParams();
      return <Redirect to={`/pih/owner/${itemOwnerId}/wheels${rest?.[0] || ''}`} />
    }
  },
  {
    path: '/owner/:itemOwnerId/treads/new',
    main: AddTreadPage,
  },
  {
    path: '/owner/:itemOwnerId/treads/:treadId',
    main: TreadPage,
  },
  {
    path: '/owner/:itemOwnerId/treads',
    main: TreadsPage,
  },
  {
    path: '/owner/:itemOwnerId/tread-items',
    main: TreadItemsPage,
  },
  {
    path: '/owner/:itemOwnerId/tread-item/:itemId',
    main: TreadItemPage
  },
];

const useStyles = makeStyles((theme) => {
  //console.log('theme', theme);
  return {
    app: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    },
    wrapper: {
      flex: 'auto',
      flexWrap: 'nowrap'
    },
    back: {
      alignItems: 'center',
      display: 'flex',
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      minHeight: '96px'
    },
    main: {
      flex: 'auto',
      minWidth: 0
    }
  }});

function App() {
  const { t } = useTranslation();
  const classes = useStyles();
  let { path } = useRouteMatch(); // "/pih"

  return (
    <div className={classes.app}>
      <NavBar />
      <Grid container className={classes.wrapper}>
        <Hidden smDown>
          <SideBar>
            <div className={classes.back}>
              <Button color="primary" component={Link} to={path} startIcon={<ChevronLeftIcon />}>{t('backToSearch')}</Button>
            </div>
            <Divider />
            <PinList />
          </SideBar>
        </Hidden>
        <main className={classes.main}>
          <Switch>
            {routes.map((route, index) => (
              <Route
                key={index}
                path={`${path}${route.path}`}
                exact={route.exact}
              >
                <route.main />
              </Route>
            ))}
          </Switch>
        </main>
      </Grid>
    </div>
  );
}

export default App;
